define.alias("ember-math-helpers/helpers/acos", "preview-grid/helpers/acos");